import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function EcommerceUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-1210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1211">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1212">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1213">
            The e-commerce leads database for{' '}
            <span className="text-blue-600" data-id="element-1214">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-1215">
            From sales to marketing, see how teams use our platform to find
            e-commerce leads and grow their revenue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1216">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1217">
            <div data-id="element-1218">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1219">
                SaaS sales to e-commerce
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1220">
                Teams selling tools to Shopify stores and WooCommerce sites use
                our built-in email sequencing to reach store owners directly,
                bypassing generic info@ emails.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1221">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1222" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1223">
                Having the database and sequencing in one tool doubled our SDRs'
                daily output.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1224">
                — Mark R., VP of Sales
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1225">
            <div data-id="element-1226">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1227">
                Agency prospecting
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1228">
                Marketing agencies find e-commerce leads by filtering for
                specific platforms, review ratings, and technologies — targeting
                the biggest Shopify stores down to emerging Shopify sites.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1229">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1230" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1231">
                The e-commerce database coverage is unmatched. We find DTC
                brands that other tools completely miss.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1232">
                — Elena S., Agency Owner
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1233">
            <div data-id="element-1234">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1235">
                Market research & investment
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1236">
                Analysts and investors track Shopify statistics, platform
                adoption trends, and e-commerce growth data across 14M+ active
                stores globally.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1237">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1238" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1239">
                We can view store owner emails before exporting, ensuring we
                only contact the actual decision makers.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1240">
                — David L., Head of Growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}